import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent, MatPaginatorIntl } from '@angular/material/paginator';
@Component({
  selector: 'nuc-paginator',
  imports: [MatPaginatorModule],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.scss'
})
export class PaginatorComponent {
  @Input() length: number;
  @Input() displayClass: string;
  @Input() pageSize: number;
  @Input() showFirstLastButtons: boolean;
  @Input() pageSizeOptions=[5,10,15,20];
  @Output() pageChange = new EventEmitter<any>();
  @Input() pageIndex: number;
  onPageChange(event: PageEvent) {
    this.pageChange.emit(event);
  }
}

